import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["hidden", "conditionId", "size", "clipboard"];

    connect() {
      this.count = parseInt(this.sizeTarget.innerText);
      this.defaultConditionField = document.getElementById("default_condition");
      this.addCondition = document.getElementById("add_condition");
      this.added_conditions = []
    }

    remove_condition(event){
      document.getElementById(`${event.target.parentNode.parentNode.id}-text`).remove();
      event.target.parentNode.parentNode.remove();
    }

    create_condition(){
      // create div
      var condition_field = document.createElement('div');
      condition_field.className = this.defaultConditionField.className;
      condition_field.classList.add("rel");
      condition_field.setAttribute("id", `custom-condition-${this.count}`);
      condition_field.setAttribute("name", `coupon_condition_field_${this.count}`);

      // create input field to pass data to backend server
      var hidden_field = document.createElement('input');
      hidden_field.setAttribute('type', 'hidden');
      hidden_field.setAttribute('value', "false");
      hidden_field.setAttribute('name', `coupon[configurations][conditions][][checked]`);

      // create checkbox field
      var checkbox_field = document.createElement('input');
      checkbox_field.classList.add("form-field-input");
      checkbox_field.setAttribute('value', false);
      checkbox_field.setAttribute('type', 'checkbox');
      checkbox_field.setAttribute('data-action', 'click->conditions#new_check')
      checkbox_field.setAttribute('id', `custom-condition-${this.count}`)
      
      // create input to enter data
      var input_field = document.createElement('input');
      input_field.classList.add("form-field-input");
      input_field.classList.add("textfield");
      input_field.setAttribute('type', 'text');
      input_field.setAttribute('name', `coupon[configurations][conditions][][name]`);
      // input_field.setAttribute('id', `coupon_condition_input_${this.count}`);
      input_field.setAttribute('data-action', 'input->conditions#textChange');
      input_field.setAttribute('required', 'true');

      // delete button
      var delete_button = document.createElement('button');
      delete_button.setAttribute('type', 'button');
      
      var span = document.createElement('span');
      span.classList.add("material-icons");
      span.innerText = "close";
      span.setAttribute('data-action', 'click->conditions#remove_condition');

      delete_button.appendChild(span);

      // append all input fields to div
      condition_field.appendChild(hidden_field);
      condition_field.appendChild(checkbox_field);
      condition_field.appendChild(input_field);
      condition_field.appendChild(delete_button);

      this.count = this.count + 1;
      this.add_condition_array(condition_field)
    }

    add_condition_array(element){
      const size = this.added_conditions.length;
      this.addCondition.parentNode.insertBefore(element, this.addCondition);
      this.added_conditions.push(element)


      var condition_field = document.createElement('li');
      condition_field.className = "fl-12 fw-normal hidden";
      condition_field.setAttribute("id", `custom-condition-${this.count-1}-text`);
      document.getElementById("coupon-frame-info").appendChild(condition_field);
    }

    check(event){
      var hidden_field = event.target.parentNode.childNodes[1];
      if (event.target.checked){
        hidden_field.setAttribute('value', "true");
        event.target.setAttribute("checked", "checked")
        document.getElementById(`${event.target.parentNode.id}-text`).classList.remove("hidden");
      }
      else{
        hidden_field.setAttribute('value', "false");
        event.target.removeAttribute("checked")
        document.getElementById(`${event.target.parentNode.id}-text`).classList.add("hidden");
      }
    }

    new_check(event){
      var hidden_field = event.target.parentNode.childNodes[0];
      if (hidden_field.hasAttribute('checked')){
        hidden_field.setAttribute('value', "false");
        hidden_field.removeAttribute('checked');
        document.getElementById(`${event.target.parentNode.id}-text`).classList.add("hidden");
      }
      else{
        hidden_field.setAttribute('value', "true")
        hidden_field.setAttribute('checked', 'checked')
        document.getElementById(`${event.target.parentNode.id}-text`).classList.remove("hidden");
      }
    }

    textChange(event) {
      document.getElementById(`${event.target.parentNode.id}-text`).innerText = event.target.value;
    }
    copyLink(event){
      var copyText = this.clipboardTarget;
      navigator.clipboard.writeText(copyText.value);
      var tooltip = document.getElementById("myTooltip");
      tooltip.innerHTML = "Copied";
      
    }
    outFunc() {
      var tooltip = document.getElementById("myTooltip");
      tooltip.innerHTML = "Copy to  clipboard";
    }
}
